export const styles = (slug?: string) => {
  return {
    innerWrapper: 'p-0 &:hover:border-white',
    inputWrapper: `!px-3 border-${slug} hover:border-${slug}`,
  }
}
